module.exports = __webpack_public_path__ + "static/media/chicken-rice.f3abb4a7.jpg";